$(function(){
	$(window).scroll(function() {
		if ($(this).scrollTop() > 10) {
			$('#mv').addClass('change');
			$('#index-content').addClass('change');
		} else {
			$('#mv').removeClass('change');
			$('#index-content').removeClass('change');
		}
		
	});

  var slide_auto = $('#slide').data('autorotate');
  var slide_speed = $('#slide').data('speed');
  $("#slide").slick({
    autoplay: slide_auto,
    fade:true,
    autoplaySpeed: slide_speed,
    dots: true,
  });
  
  $('.shopify-section.index-section.index-section--flush').each(function(){
    $(this).addClass('grid__item_'+$(this).find('.grid__item').length);
  });
});